/**
 * Deprecation gate for this app.
 *
 * This is the old Vue organizer app, still served at lite.gobo.show. The
 * organizer experience now lives in the Next.js app at app.gobo.show, and over
 * the 30 days to 2026-09-21 exactly one account signed in here -- 47 logins and
 * not one event, profile, or venue touched. So the app stays up for the
 * accounts below and shows everybody else the way to the new one.
 */

/**
 * The only accounts allowed to stay signed in. Everyone else is signed out on
 * sight, whichever of this app's sign-in paths they came through.
 */
export const ALLOWED_EMAILS = ["josh@gobo.show", "support@gobo.show"];

/**
 * Whether an account may use this app.
 *
 * @param {?string} email The signed-in account's email.
 * @return {boolean} True when the account is allowed to stay.
 */
export function isAllowedEmail(email) {
  if (!email) return false;
  return ALLOWED_EMAILS.includes(
    String(email)
      .trim()
      .toLowerCase()
  );
}

/**
 * Where to send everybody else.
 *
 * Read from the Firebase project this build points at rather than a URL of its
 * own, so a test build can only ever send people to the test app -- the same
 * way the cloud functions decide which environment they are in.
 *
 * @return {string} The new app's origin, no trailing slash.
 */
export function newAppUrl() {
  const projectId =
    process.env.VUE_APP_FIREBASE_PROJECTID ||
    process.env.VUE_APP_FIREBASE_PROJECT_ID;
  return projectId === "gobo-app"
    ? "https://app.gobo.show"
    : "https://app-test.gobo.show";
}
